import * as React from 'react';
import { findIcon } from '../../../gfx/svgsprite-imports';
import IconPolyfill from './icon.polyfill';
import { isDev } from '../../utils/envCheck';
export interface IconProps {
  className?: string;
  iconType: string;
  isAriaHidden?: boolean;
  ariaLabel?: string;
  title?: string;
}

/**
 * This class renders a SVG icon with the given name.
 * All SVG icons should either be labeled as aria-hhidden:true or must have a aria-label if they are not hidden.
 */
export class Icon extends React.Component<IconProps> {
  static defaultProps = {
    className: '',
    ariaLabel: '',
    isAriaHidden: true,
  };

  constructor(props: IconProps) {
    super(props);

    if (!this.props.isAriaHidden && !this.props.ariaLabel) {
      throw new Error('Icons that are aria-hidden set to false must have aria-label.');
    }
  }

  public render() {
    const { className, iconType, isAriaHidden, ariaLabel, title } = this.props;
    const icon = findIcon(iconType);
    if (isDev() && !icon) {
      console.warn(`${iconType} is not a known icon`);
    }
    const symbol = icon.symbol;
    let extraAttributes: React.HTMLAttributes<any> = {};
    if (ariaLabel) {
      extraAttributes['aria-label'] = ariaLabel;
      extraAttributes.role = 'img';
    }

    return icon ? (
      <svg viewBox={icon.viewBox} className={className} aria-hidden={isAriaHidden} {...extraAttributes}>
        <IconPolyfill icon={icon} />
        {title && <title>{title}</title>}
        <use xlinkHref={symbol} href={symbol} />
      </svg>
    ) : null;
  }
}
